module.exports = __webpack_public_path__ + "static/christmas-cat-f0a1967106ca34d2cf44ee0405d2fa2e.jpg";